// extracted by mini-css-extract-plugin
export default {"stickyArticleHeader":"H_bT","stickyArticleHeaderContainer":"H_bV","stickyArticleHeaderButton":"H_bW","text_left":"H_bX","progressContainer":"H_bY","progressBar":"H_bZ"};